module.exports = __webpack_public_path__ + "static/media/wood.e523efa3.jpg";